import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Text } from '@nextiva/next-ui';
import { Tooltip } from '@nextiva/next-ui-components';
import { dataSelector } from '@nextiva/global-store';
import '@nextiva/global-header__simple-header/dist/styles.css';

import './Header.scss';

const blockName = 'header';

const AppHeader = ({ title, help, data, helpTooltipText }) => {
  return (
    !data.isLoading && (
      <>
        <div className={blockName}>
          <Text className={`${blockName}__title`} kind="h1">
            {title}
          </Text>
          {help && (
            <Tooltip title={helpTooltipText} placement="bottom">
              <span className={`${blockName}__help`}>
                <i>?</i>
                Help
              </span>
            </Tooltip>
          )}
        </div>
      </>
    )
  );
};

AppHeader.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  help: PropTypes.bool,
  helpTooltipText: PropTypes.string.isRequired,
};

AppHeader.defaultProps = {
  blockName: false,
};

const mapStateToProps = state => ({
  data: dataSelector(state),
  helpTooltipText: state.billingLanding.helpTooltipText,
});

export default connect(mapStateToProps)(AppHeader);
